export const ENTER_KEY_CODE = 13

export const SPACE_KEY_CODE = 32

const onKeyDownHelper = (e, callback) => {
  if (
    (e.keyCode === ENTER_KEY_CODE || e.keyCode === SPACE_KEY_CODE) &&
    callback
  ) {
    callback()
  }
}

export default onKeyDownHelper
